import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { ApiService } from 'src/app/api.service';
import { OrganisationService } from 'src/app/organisation.service';
import { MatTableModule, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow]
})
export class UsersComponent implements OnInit {
  hasApiError = false;
  apiError: string = '';
  users: Array<any> = [];
  displayedColumns: string[] = ['picture', 'name', 'level', 'email'];
  inContextOrgId: string = '';

  constructor(
    public auth: AuthService,
    private api: ApiService,
    private orgService: OrganisationService
  ) { }

  ngOnInit() {
    this.orgService.currentOrg$.subscribe((org) => {
      this.inContextOrgId = (org && org.id) ? org.id : '';
    });

    this.hasApiError = false;
    this.auth.user$.subscribe({
      next: (profile) => {
        if (profile?.sub) {
          this.api.getUsersId$(profile.sub).subscribe({
            next: (user) => {
              // If the user has an org id and is an admin, get all users in the org
              if (this.inContextOrgId && this.inContextOrgId != '') {
                this.api.getOrganisationsIdUsers$(this.inContextOrgId).subscribe({
                  next: (users) => {
                    this.users = users;
                  }
                });
              }
            }
          });
        }
      }
    });
  }
}
